import React from 'react';
import { Tune } from '@material-ui/icons';
import FormConfigSlider from '../../config/FormConfigSlider';
import FormSlider from '../../fields/FormSlider';
export const FormSliderPlugin = {
    icon: React.createElement(Tune, null),
    name: 'Slider',
    type: 'Slider',
    dataTypes: ['text', 'integer', 'numeric'],
    configurator: FormConfigSlider,
    element: FormSlider
};
//# sourceMappingURL=FormSliderPlugin.js.map